export default __webpack_public_path__ + "static/media/logo.a73e1567.png";